import AbstractAnalyticsProvider from './AbstractAnalyticsProvider';
import { resolvePlatform } from '@/utils/platformResolver';

type WindowWithDataLayer = Window & {
  dataLayer: Array<Record<string, unknown>>;
};

declare const window: WindowWithDataLayer;

class TagManagerProvider extends AbstractAnalyticsProvider {
  trackEcommerceEvent(payload: Record<string, unknown>) {
    const requiredFields = ['event', 'clear-eventAction', 'clear-eventLabel', 'ecommerce'];

    this.validateRequiredFields(requiredFields, payload as Record<string, string>);

    try {
      this.track({ ...payload, 'clear-eventCategory': 'Ecommerce' });
    } catch (e) {
      console.error(e);
    }
  }

  trackCheckoutEvent(payload: { event: string; 'clear-eventAction': string; 'clear-eventLabel'?: string }) {
    this.validateRequiredFields(['event', 'clear-eventAction'], payload);

    try {
      this.track({ ...payload, 'clear-eventCategory': 'checkout' });
    } catch (e) {
      console.error(e);
    }
  }

  logOTCEmailSubmit() {
    this.track({
      event: 'enter-email',
      'clear-eventCategory': 'login-form-main',
      'clear-eventAction': 'enter-email',
      'clear-eventLabel': resolvePlatform(),
    });
  }

  logOTCCodeSubmitSuccess() {
    this.track({
      event: 'verification-code',
      'clear-eventCategory': 'login-form-main',
      'clear-eventAction': 'verification-code',
      'clear-eventLabel': resolvePlatform(),
    });
  }

  logOTCEmailResend() {
    this.track({
      event: 'profile',
      'clear-eventCategory': 'profile',
      'clear-eventAction': 'resend_click',
      'clear-eventLabel': resolvePlatform(),
    });
  }

  track(payload: Record<string, unknown>): void {
    if (typeof window?.dataLayer !== 'undefined') window.dataLayer.push(payload);
    else throw new Error("Couldn't log the GTM event, as the `window` and/or `dataLayer` are not accessible");
  }
}

export default TagManagerProvider;
